document.documentElement.classList.remove('no-js');
document.documentElement.classList.add('js');

document.addEventListener('DOMContentLoaded',()=>{
  const body=document.body;
  const header=document.querySelector('.site-header');
  const btn=document.querySelector('.menu');
  const nav=document.querySelector('.mobile-nav');
  const reduce=window.matchMedia('(prefers-reduced-motion: reduce)').matches;

  requestAnimationFrame(()=>body.classList.add('studio-loaded'));

  const closeMenu=()=>{
    if(!btn||!nav) return;
    nav.classList.remove('open');
    btn.setAttribute('aria-expanded','false');
    btn.setAttribute('aria-label','Open menu');
    btn.textContent='☰';
    body.classList.remove('studio-menu-open');
  };
  const openMenu=()=>{
    if(!btn||!nav) return;
    nav.classList.add('open');
    btn.setAttribute('aria-expanded','true');
    btn.setAttribute('aria-label','Close menu');
    btn.textContent='×';
    body.classList.add('studio-menu-open');
  };

  if(btn&&nav){
    btn.addEventListener('click',()=>nav.classList.contains('open')?closeMenu():openMenu());
    nav.querySelectorAll('a').forEach(link=>link.addEventListener('click',closeMenu));
    document.addEventListener('keydown',e=>{if(e.key==='Escape') closeMenu();});
    document.addEventListener('click',e=>{
      if(nav.classList.contains('open')&&!nav.contains(e.target)&&!btn.contains(e.target)) closeMenu();
    });
    window.addEventListener('resize',()=>{if(window.innerWidth>980) closeMenu();},{passive:true});
  }

  const onScroll=()=>{if(header) header.classList.toggle('is-scrolled',window.scrollY>12);};
  onScroll();
  window.addEventListener('scroll',onScroll,{passive:true});

  if(!reduce && 'IntersectionObserver' in window){
    const sectionSelector='main > section:not(.studio-v4-hero)';
    const itemSelector=[
      '.studio-v4-proofbar .container > div',
      '.studio-v4-problem-grid article',
      '.studio-v4-deliverables article',
      '.studio-v4-case-grid article',
      '.studio-v4-tier-grid article',
      '.studio-v4-principles article',
      '.review-process-grid article',
      '.studio-v4-channelcards article',
      '.pdp-visual article',
      '.proof-card','.service','.support-cards article','.work-card','.v14-offer-track article'
    ].join(',');

    const sections=[...document.querySelectorAll(sectionSelector)];
    sections.forEach(el=>el.classList.add('studio-motion-section'));
    const sectionObserver=new IntersectionObserver(entries=>{
      entries.forEach(entry=>{
        if(entry.isIntersecting){entry.target.classList.add('is-visible');sectionObserver.unobserve(entry.target);}
      });
    },{threshold:.07,rootMargin:'0px 0px -36px 0px'});
    sections.forEach(el=>sectionObserver.observe(el));

    const items=[...document.querySelectorAll(itemSelector)];
    items.forEach(el=>el.classList.add('studio-motion-item'));
    const itemObserver=new IntersectionObserver(entries=>{
      entries.forEach(entry=>{
        if(!entry.isIntersecting) return;
        const el=entry.target;
        const siblings=[...el.parentElement.children].filter(x=>x.classList.contains('studio-motion-item'));
        const index=Math.max(0,siblings.indexOf(el));
        el.style.transitionDelay=`${Math.min(index,5)*55}ms`;
        el.classList.add('is-visible');
        itemObserver.unobserve(el);
      });
    },{threshold:.08,rootMargin:'0px 0px -24px 0px'});
    items.forEach(el=>itemObserver.observe(el));
  }
});
